import React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn, buildRoute } from 'modules/core/lib/react-router'

const AssessmentsPage = React.lazy(
  () => import('modules/competencies/pages/performance/AssessmentsPage')
)
const NineBoxPage = React.lazy(() => import('modules/competencies/pages/performance/NineBoxPage'))
const RootPage = React.lazy(() => import('modules/competencies/pages/performance/RootPage'))

const performanceRoutes: NavigationRoutesFn = (navigation) => {
  return [
    buildRoute({
      path: navigation.performance.competencies.path,
      element: <RootPage />,
      handle: {
        meta: () => {
          return {
            title: i18n.t('competencies_v2.tabs.competencies'),
            illustration: 'window-user',
            subNavigation: [
              {
                index: true,
                title: i18n.t('competencies_v2.tabs.assessments'),
                href: navigation.performance.competencies.fullPath(),
              },
              {
                title: i18n.t('competencies_v2.tabs.ninebox'),
                href: navigation.performance.competencies.ninebox.fullPath(),
              },
            ],
          }
        },
      },
      children: [
        {
          index: true,
          element: <AssessmentsPage />,
        },
        {
          path: navigation.performance.competencies.ninebox.path,
          element: <NineBoxPage />,
        },
      ],
    }),
  ]
}

export default performanceRoutes
